import React, { forwardRef } from 'react';
import { bool, func, node, shape, string } from 'prop-types';

import { styRadioWrapper, styRadioOuter } from './style';

const InputRadioItem = forwardRef((props, ref) => {
  const {
    id,
    name,
    checked,
    children,
    className,
    disabled,
    onChange,
    style,
    textColor,
    value,
    ...inputProps
  } = props;

  const handleChange = () => {
    if (disabled) return;

    const event = { ...new Event('change') };
    event.target = { value, checked: !checked };
    onChange(event);
  };

  const styProps = {
    color: textColor,
    checked,
    disabled,
  };

  return (
    <label htmlFor={id} className={`${className} ${styRadioWrapper(styProps)}`} style={style}>
      <span className={styRadioOuter(styProps)}>
        <input
          ref={ref}
          id={id}
          data-testid={id}
          name={name}
          type="radio"
          value={value}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          readOnly={disabled}
          {...inputProps}
        />
      </span>
      <span>{children}</span>
    </label>
  );
});

InputRadioItem.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  checked: bool,
  children: node,
  className: string,
  disabled: bool,
  onChange: func,
  style: shape({}),
  textColor: string,
  value: string,
};

InputRadioItem.defaultProps = {
  checked: false,
  children: null,
  className: '',
  disabled: false,
  onChange: () => {},
  style: {},
  textColor: '',
  value: '',
};

export default InputRadioItem;
